import React from 'react';
import Login from './components/Login';
import Home from './views/Home';

const App = () => {
	return (
		<Home/>
	);
} 

export default App;
